import translations from './OrderingFilters.translations'

export const DEFAULT_TAB = 0
export const DEFAULT_LISTINGS_PER_PAGE_COUNT = 10
export const LISTINGS_PER_PAGE_COUNT_OPTIONS = [
  DEFAULT_LISTINGS_PER_PAGE_COUNT,
  20,
  30,
]

export const VIEWS = {
  SIMPLE: 'simple',
  EXPANDED: 'expanded',
}

export const ORDER_BY = {
  STOCK_ASC: 'quantity',
  STOCK_DESC: '-quantity',
  ALPHABETICAL_ASC: 'title',
  ALPHABETICAL_DESC: '-title',
}

export const SORT_OPTIONS = [
  {
    label: translations.sortStockAscending,
    value: ORDER_BY.STOCK_ASC,
  },
  {
    label: translations.sortStockDescending,
    value: ORDER_BY.STOCK_DESC,
  },
  {
    label: translations.sortAlphabeticalAscending,
    value: ORDER_BY.ALPHABETICAL_ASC,
  },
  {
    label: translations.sortAlphabeticalDescending,
    value: ORDER_BY.ALPHABETICAL_DESC,
  },
]
